import { FuelAvatar, FuelTag, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { DS_TOKENS } from 'constants/styled.contants';
import { ITruckerProfileProps } from 'interfaces/profile.interface';
import KebabMenu from 'open-search/components/KebabMenu';
import { TKebabMenuProps } from 'open-search/types';
import React from 'react';
import { isEmpty } from 'utils/validate';
import * as Styled from './styled';

type THeaderProps = ITruckerProfileProps & { kebabProps: TKebabMenuProps };

const Header = ({ trucker, isVerified, kebabProps }: THeaderProps) => (
  <FuelFlex defaultProps={{ gap: 'km4', alignItems: 'flex-start' }}>
    <Styled.BackgroundTop isVip={trucker?.isVip} />

    <FuelFlex defaultProps={{ justifyContent: 'center', flexDirection: 'column', width: '100%' }}>
      <FuelFlex defaultProps={{ width: '100%' }}>
        <FuelAvatar
          size="large"
          icon={!trucker?.selfieUri ? 'user-area' : null}
          data-testid="trucker-selfie"
          key="avatar-photo"
          verified={isVerified}
        >
          <Styled.BorderImage slot="image" />

          {!isEmpty(trucker?.selfieUri) && (
            <img slot="image" src={trucker?.selfieUri} alt={`${trucker?.name} profile`} data-testid="trucker-icon" />
          )}
          <Styled.NameWrapper slot="title" isVerified={isVerified}>
            <FuelTypography
              size="body-md"
              weight="bold"
              color={trucker?.isVip ? 'neutral-inverted' : 'neutral-strong'}
              data-testid="trucker-name"
            >
              {trucker?.name?.toLowerCase()}
            </FuelTypography>
          </Styled.NameWrapper>
          {trucker?.vehicles?.[0]?.tractor?.type && (
            <Styled.VehiclesTypeWrapper slot="description">
              <FuelTypography
                size="body-sm"
                color={trucker?.isVip ? 'neutral-weak' : 'neutral-default'}
                weight="medium"
                spacingBottom={parseFloat(DS_TOKENS.spacing.km1)}
                spacingTop={parseFloat(DS_TOKENS.spacing.km1)}
                data-testid="trucker-main-vehicle"
              >
                {trucker.vehicles[0].tractor.type}
                {trucker.vehicles?.[0]?.body[0]?.name && (
                  <>
                    {' • '}
                    {trucker.vehicles[0].body[0].name}
                  </>
                )}
              </FuelTypography>
            </Styled.VehiclesTypeWrapper>
          )}
          <Styled.BaseInfo slot="description">
            {trucker?.phones?.length > 0 && (
              <FuelTypography size="body-sm" color="neutral-default" weight="medium">
                DDD: (
                {trucker?.phones
                  ?.map((code) => code.ddd)
                  .filter((ddd, index, array) => array.indexOf(ddd) === index)
                  .join('), (')}
                )
              </FuelTypography>
            )}
          </Styled.BaseInfo>
        </FuelAvatar>
        <FuelFlex
          defaultProps={{
            justifyContent: 'flex-end',
            flexGrow: 1,
            flexShrink: 1,
            flexBasis: 'auto',
            customMargin: `0 0 0 ${DS_TOKENS.spacing.km1}`,
          }}
        >
          <KebabMenu {...kebabProps} />
        </FuelFlex>
      </FuelFlex>

      {trucker?.isVip && (
        <Styled.VipTagWrapper>
          <FuelTag slot="tag" highlight label="MOTORISTA VIP" shape="rectangle" data-testid="trucker-vip-tag" />
        </Styled.VipTagWrapper>
      )}
    </FuelFlex>
  </FuelFlex>
);

export default Header;
